import type { CardStackExtracted } from "@shared/models/card-stack"
import { extractLessonStandards } from "@shared/unified-tiptap/extensions/standard/standard-extension"
import type { CardAttrsBase } from "@shared/unified-tiptap/util/card"
import { Node as PMNode } from "@tiptap/pm/model"

/**
 * Computes a UnifiedCardStack's `extracted` property from its content.
 *
 * @param commentIds Comment IDs on the whole lesson.
 */
export function extractFromProseMirrorDoc(doc: PMNode): CardStackExtracted {
  return {
    standards: extractLessonStandards(doc),
    cardCommentIds: extractCardCommentIds(doc),
  }
}

export function emptyCardStackExtracted(): CardStackExtracted {
  return {
    standards: [],
    cardCommentIds: [],
  }
}

function extractCardCommentIds(doc: PMNode): string[] {
  const commentIds: string[] = []
  doc.descendants((node) => {
    if (node.type.isInGroup("card")) {
      commentIds.push(...(node.attrs as CardAttrsBase).commentIds)
    }
  })
  return commentIds
}
